module.exports = __webpack_public_path__ + "static/media/bytte-lyd-test-finished.8cd7beab.mp3";